import * as Images from '../../Images';
import { Avatar, Grid, Typography } from '@mui/material';

export const TestImages = () => {
  const imageSources = Object.values(Images);
  const imageNames = Object.keys(Images);

  if (process.env.NODE_ENV === 'development') {
    return (
      <Grid container>
        {imageSources.map((src, index) => (
          <Grid
            item
            key={index}
            sx={{ border: '1px solid', p: '20px', maxWidth: '20%' }}
          >
            <Avatar
              src={src}
              alt=''
              sx={{
                maxWidth: '80px',
                maxHeight: '120px',
                width: 'auto',
                height: 'auto',
              }}
            />
            <Typography variant='caption'>{imageNames[index]}</Typography>
          </Grid>
        ))}
      </Grid>
    );
  } else {
    window.location.href = '/';
    return null;
  }
};
